import { useNavigate } from 'react-router-dom';
import useColorPalette from '../../hooks/useColorPalette';

export default function EmptyRecords({
    label,
}: {
    label: 'Files' | 'Datasets' | 'Model Family' | 'Resultsets' | 'Read-Across',
}) {
    const navigate = useNavigate();
    const { palette } = useColorPalette();

    const redirect = () => {
        let link = '';

        if (label === 'Files') {
            link = '/files'
        } else if (label === 'Datasets') {
            link = '/datasets'
        } else if (label === 'Model Family') {
            link = '/models'
        } else if (label === 'Resultsets') {
            link = '/resultsets'
        } else {
            link = '/readacross'
        }

        navigate(link);
    };

    return (
        <div className="w-full flex flex-col justify-center items-center p-10 gap-4 grow h-full">
            <img src={`${process.env.PUBLIC_URL}/no-records/${palette.logo}`} className="w-[160px]" alt='no-records'/>
            <h2 className="text-[18px] font-semibold">No Records Found</h2>
            <button 
                onClick={redirect} 
                className="py-2 px-7 text-white bg-primary rounded font-medium hover:brightness-90 transition-all mt-4"
            >
                Return to {label} Page
            </button>
        </div>
    )
}